'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _toConsumableArray = require('@babel/runtime-corejs3/helpers/toConsumableArray');
var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _filterInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/filter');
var _forEachInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/for-each');
var _mapInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/map');
var _includesInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/includes');
require('../expression/index.js');
require('../utils/index.js');
var parseJson = require('../expression/parse-json.js');
var formatValidator = require('../utils/format-validator.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _toConsumableArray__default = /*#__PURE__*/_interopDefaultLegacy(_toConsumableArray);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _filterInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_filterInstanceProperty);
var _forEachInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_forEachInstanceProperty);
var _mapInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_mapInstanceProperty);
var _includesInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_includesInstanceProperty);

var PatternAggregation = /*#__PURE__*/function () {
  function PatternAggregation(data, schema) {
    _classCallCheck__default["default"](this, PatternAggregation);
    this.name = data.name;
    this.expression = parseJson.parseExprJson(data.expression, schema);
  }
  return _createClass__default["default"](PatternAggregation, [{
    key: "toJson",
    value: function toJson() {
      return {
        name: this.name,
        expression: this.expression.toJson()
      };
    }

    /**
     * Check whether aggergation name is valid.
     *
     * @param {string[]} otherAggNames
     * @param {Graph} schema
     * @returns {ValidateResult}
     * @memberof PatternAggregation
     */
  }, {
    key: "checkAggregationName",
    value: function checkAggregationName(otherAggNames, schema, aliasSchema) {
      var _this = this;
      if (!this.name) {
        return {
          success: false,
          message: 'Name cannot be empty.'
        };
      }
      // Check name duplication.
      if (_filterInstanceProperty__default["default"](otherAggNames).call(otherAggNames, function (aggName) {
        return aggName === _this.name;
      }).length > 1) {
        return {
          success: false,
          message: 'Name cannot be duplicated.'
        };
      }
      // Check name cannot be same as attribute name.
      if (schema) {
        var _context, _context3;
        var attrNames = [];
        _forEachInstanceProperty__default["default"](_context = schema.vertexTypes).call(_context, function (vType) {
          var _context2;
          return attrNames.push.apply(attrNames, _toConsumableArray__default["default"](_mapInstanceProperty__default["default"](_context2 = vType.attributes).call(_context2, function (attr) {
            return attr.name;
          })));
        });
        _forEachInstanceProperty__default["default"](_context3 = schema.edgeTypes).call(_context3, function (eType) {
          var _context4;
          return attrNames.push.apply(attrNames, _toConsumableArray__default["default"](_mapInstanceProperty__default["default"](_context4 = eType.attributes).call(_context4, function (attr) {
            return attr.name;
          })));
        });
        if (_includesInstanceProperty__default["default"](attrNames).call(attrNames, this.name)) {
          return {
            success: false,
            message: 'Cannot use an attribute name.'
          };
        }
      }
      if (aliasSchema) {
        var _context5, _context6;
        var vertexAndEdgeAlias = [];
        _forEachInstanceProperty__default["default"](_context5 = aliasSchema.vertexTypes).call(_context5, function (vType) {
          return vertexAndEdgeAlias.push(vType.name);
        });
        _forEachInstanceProperty__default["default"](_context6 = aliasSchema.edgeTypes).call(_context6, function (eType) {
          return vertexAndEdgeAlias.push(eType.name);
        });
        if (_includesInstanceProperty__default["default"](vertexAndEdgeAlias).call(vertexAndEdgeAlias, this.name)) {
          return {
            success: false,
            message: 'Cannot use an alias of vertex or edge.'
          };
        }
      }
      return formatValidator.FormatValidator.isName(this.name);
    }
  }]);
}();

exports.PatternAggregation = PatternAggregation;
